import React, {Component} from 'react';
import DisplayBox from '../../hoc/DisplayBox/DisplayBox';
import Button from '../../UI/Button/Button';
import Modal from '../../UI/Modal/Modal';
import Input from '../../UI/Input/Input';
import Spinner from '../..//UI/Spinner/Spinner';
import DisablePopUp from './DisablePopUp';
import { connect } from 'react-redux';
import * as actions from '../../store/actions/index';
import Message from '../../components/Message/Message';
import classes from './DisableAccount.css';
import { checkValidity } from '../../shared/utility';
import { BULK_DISABLE, BULK_LOCKING, BULK_DELETE, BULK_DELETE_WITH_FILENAME, BULK_EIMP_SYNC, BULK_EIMP_SYNC_WITH_FILENAME, BULK_LDAP_UNLOCK } from '../../shared/Constants';
import ConfirmPopUp from './ConfirmPopup';
import ConfirmStopPopUp from './ConfirmStopPopup';

class DisableAccounts extends Component{

    state = {
        file:'',
        showModal: false,
        confirmShowModal: false,
        errorMsg: null,
        attachment: null,
        fileName: '',
        jobId: '',
        fromOutputFolder: false,
        disableAccountsForm: {
            userActivity: {
                elementType: 'select',
                elementConfig: {
                    type: 'text',
                    id: 'languages',
                    placeholder: 'Select One',
                    options: [
                        { value: 'bulkDisable', displayValue: 'Bulk Disable' },
                        { value: 'bulkLocking', displayValue: 'Bulk Locking (LDAP Lock)' },
                        { value: 'bulkLdapUnlock', displayValue: 'Bulk Unlocking (LDAP / Password Lock)' },
                        ...(this.props.userInfo.featureTestRole ? [
                            { value: 'bulkEimpSync', displayValue: 'Bulk Eimp Sync' },
                            { value: 'bulkEimpSyncWithFilename', displayValue: 'Bulk Eimp Sync With Filename' },
                            { value: 'bulkDelete', displayValue: 'Bulk Delete' },
                            { value: 'bulkDeleteWithFilename', displayValue: 'Bulk Delete With Filename' },
                            { value: 'cancelBulkUserActivity', displayValue: 'Cancel Bulk User Activity' },
                        ] : [])
                    ]
                },                
                validation: {
                    required: false
                },
                valid: true,
                value: "",
                touched: false,
                inputType: "QuarterBulk"
            }
        },
        isBrowseBtnDisabled: true,
        selectedBulkActivity: null,
        skipOptions: {
            skipHsidPdb: false,
            skipAikyam: false,
            skipKafka: true
        }
    }
    componentDidMount() {
        window.scrollTo(0, 0);
    }

        componentDidUpdate(prevProps, prevState) {
        if(prevProps.userInfo.featureTestRole !== this.props.userInfo.featureTestRole && this.props.userInfo.featureTestRole
        ){
            this.setState({disableAccountsForm:{
                userActivity: {
                    ...this.state.disableAccountsForm.userActivity,
                    elementConfig: {
                        ...this.state.disableAccountsForm.userActivity.elementConfig,
                        options: [
                            ...this.state.disableAccountsForm.userActivity.elementConfig.options,
                            { value: 'bulkEimpSync', displayValue: 'Bulk Eimp Sync' },
                            { value: 'bulkEimpSyncWithFilename', displayValue: 'Bulk Eimp Sync With Filename' },
                            { value: 'bulkDelete', displayValue: 'Bulk Delete' },
                            { value: 'bulkDeleteWithFilename', displayValue: 'Bulk Delete With Filename' },
                            { value: 'cancelBulkUserActivity', displayValue: 'Cancel Bulk User Activity' },
                        ]
                }}
            }})
        }
    }
    
    toggleModalHandler = () => {
        this.setState({showModal: !this.state.showModal, attachment: null, file: '', fileName: '', fromOutputFolder: false,
            skipOptions: { skipHsidPdb: false, skipAikyam: false, skipKafka: true}
        });
        this.props.setResponseToNull();
    }

    toggleConfirmModalHandler = () => {
        this.setState({confirmShowModal: !this.state.confirmShowModal});
    }

    toggleConfirmStopModalHandler = () => {
        this.setState({confirmStopShowModal: !this.state.confirmStopShowModal});
    }

    checkFileType(e){
        let fileValidType = ".csv";
        var fileName = e.target.files[0].name;
        var fileExt = fileName.substring(fileName.lastIndexOf('.'));
        if (fileExt !== "" && fileValidType.indexOf(fileExt) < 0) {
            this.setState({errorMsg: "Provided file is not a .csv "+fileName, attachment: null})
            e.target.value=null;
        }
        else {
            this.setState({file:e.target.files[0], attachment: fileName, errorMsg: null});
        }
    }

    handleSubmit = (event) => {
        this.setState({confirmShowModal: false})
        event.preventDefault();
        if(this.state.file !== ''){
            this.setState({showModal: true})
            const formData = new FormData();
            formData.append('file', this.state.file);
            if(this.state.selectedBulkActivity===BULK_DISABLE){
                this.props.bulkDisableAccounts(formData, this.props.userAuthToken);
            }else if(this.state.selectedBulkActivity===BULK_LOCKING){
                this.props.bulkLockingAccounts(formData, this.props.userAuthToken);
            } else if (this.state.selectedBulkActivity===BULK_LDAP_UNLOCK){
                this.props.bulkLdapUnlockAccounts(formData, this.props.userAuthToken);
            } else if (this.state.selectedBulkActivity===BULK_DELETE){
                this.props.bulkDeleteAccounts(formData, this.props.userAuthToken, this.state.skipOptions);
            } else if (this.state.selectedBulkActivity===BULK_EIMP_SYNC){
                this.props.bulkEimpSyncUuids(formData, this.props.userAuthToken);
            }
        }
        if(this.state.fileName !== ''){
            this.setState({showModal: true});
            const fileData = {
                fileName: this.state.fileName,
                fromOutputFolder: this.state.fromOutputFolder,
                skipOptions: this.state.skipOptions,

            }
            if (this.state.selectedBulkActivity===BULK_DELETE_WITH_FILENAME){
                this.props.bulkDeleteWithFilenameAccounts(fileData, this.props.userAuthToken);
            }
            if (this.state.selectedBulkActivity===BULK_EIMP_SYNC_WITH_FILENAME){
                this.props.bulkEimpSyncWithFilenameAccounts(fileData, this.props.userAuthToken);
            }
        }
    }

    handleSubmitStop = (event) => {
        this.setState({confirmStopShowModal: false})
        event.preventDefault();
        this.props.bulkDeleteStop(this.state.jobId, this.props.userAuthToken);
        this.setState({jobId: ''})
    }

    inputChangedHandler = (event, inputIdentifier) => {

        let updatedForm = { ...this.state.disableAccountsForm };

        const updatedFormElement = { ...updatedForm[inputIdentifier] };
        let targetValue = event.target.value;
        updatedFormElement.value = targetValue;
        let formIsValid = true;
        updatedForm[inputIdentifier] = updatedFormElement;
    
        if (targetValue) {
          const validation = checkValidity(
            updatedFormElement.value,
            updatedFormElement.validation
          );
          updatedFormElement.valid = validation.isValid;
          this.setState({ isBrowseBtnDisabled: (targetValue === "bulkDeleteWithFilename" || targetValue === "bulkEimpSyncWithFilename" ), selectedBulkActivity: targetValue,
            fileName: '', fromOutputFolder: false, skipOptions: { skipHsidPdb: false, skipAikyam: false, skipKafka: true},
           })
        } else {
          updatedFormElement.valid = false;
          this.setState({ isBrowseBtnDisabled: true, selectedBulkActivity: null, fileName: '', fromOutputFolder: false,
            skipOptions: { skipHsidPdb: false, skipAikyam: false, skipKafka: true},
           })
        }
    
        updatedFormElement.touched = true;
        updatedForm[inputIdentifier] = updatedFormElement;
    
        for (let inputIdentifier in updatedForm) {
          formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
        }
        this.setState({ disableAccountsForm: updatedForm, file: '', attachment: null });
    }

    changeFileNameHandler = (event) => {
        this.setState({ fileName: event.target.value });
    }

    changeJobIdHandler = (event) => {
        this.setState({ jobId: event.target.value });
    }

    handleCheckboxChange=()=>{
        this.setState({fromOutputFolder: !this.state.fromOutputFolder});
    }

    handleSkipCheckboxChange = (skipItem) => {
        this.setState((prev) => ({
            skipOptions: {
            ...prev.skipOptions,
            [skipItem]: !prev.skipOptions[skipItem],
            },
        }));
    }

    isValidFilename() {
        if(this.state.fileName) {
            const isValid = this.state.fileName.endsWith('.csv');
            return !isValid;
        }
        return false;
    }

    render(){
        const stateError = this.state.errorMsg!==null?<Message msgType="Error" info={{message: this.state.errorMsg}} />:null;
        const modalWindow = this.state.showModal || this.props.spinnerProcessing?(
            <Modal show={this.state.showModal || this.props.spinnerProcessing} modalClosed={this.toggleModalHandler}>
                {this.props.spinnerProcessing?<Spinner/>:
                <DisablePopUp
                    successResponse = {this.state.selectedBulkActivity===BULK_DISABLE ? this.props.bulkDisableResponse : 
                        (this.state.selectedBulkActivity===BULK_LOCKING ? this.props.bulkLockingResponse :
                        this.state.selectedBulkActivity===BULK_LDAP_UNLOCK ? this.props.bulkLdapUnlockResponse :
                        this.state.selectedBulkActivity===BULK_EIMP_SYNC ? this.props.bulkEimpSyncResponse :
                         this.state.selectedBulkActivity===BULK_EIMP_SYNC_WITH_FILENAME ? this.props.bulkEimpSyncResponse : this.props.bulkDeleteResponse)}
                    errorResponse = {this.state.selectedBulkActivity===BULK_DISABLE ? this.props.bulkDisableErrorResponse : 
                        (this.state.selectedBulkActivity===BULK_LOCKING ? this.props.bulkLockingErrorResponse :
                         this.state.selectedBulkActivity===BULK_LDAP_UNLOCK ? this.props.bulkLdapUnlockErrorResponse :
                         this.state.selectedBulkActivity===BULK_EIMP_SYNC ? this.props.bulkEimpSyncErrorResponse :
                          this.state.selectedBulkActivity===BULK_EIMP_SYNC_WITH_FILENAME ? this.props.bulkEimpSyncErrorResponse :this.props.bulkDeleteErrorResponse)}
                    closeModal = {this.toggleModalHandler}
                />}
            </Modal>
        ):null;

        const confirmModalWindow = this.state.confirmShowModal ? (
            <Modal show={this.state.confirmShowModal} modalClosed={this.toggleConfirmModalHandler}>
                <ConfirmPopUp
                    bulkUserActivityName = {this.state.selectedBulkActivity===BULK_DISABLE ? "BULK DISABLE" : 
                        (this.state.selectedBulkActivity===BULK_LOCKING ? "BULK LOCKING (LDAP Lock)" :
                         this.state.selectedBulkActivity===BULK_LDAP_UNLOCK ? "BULK LDAP UNLOCK (Password Unlock)" :
                         this.state.selectedBulkActivity===BULK_EIMP_SYNC ? "BULK EIMP SYNC" :
                         this.state.selectedBulkActivity===BULK_EIMP_SYNC_WITH_FILENAME ? "BULK EIMP SYNC WITH FILENAME" :
                         this.state.selectedBulkActivity===BULK_DELETE ? "BULK DELETE"
                            :"BULK DELETE WITH FILENAME"
                        )}
                    fileName = {this.state.file.name || this.state.fileName}
                    handleSubmit = {this.handleSubmit}
                    cancelled = {this.toggleConfirmModalHandler}
                />
            </Modal>
        ):null;

        const confirmStopModalWindow = this.state.confirmStopShowModal ? (
            <Modal show={this.state.confirmStopShowModal} modalClosed={this.toggleConfirmStopModalHandler}>
                <ConfirmStopPopUp
                    handleSubmit = {this.handleSubmitStop}
                    cancelled = {this.toggleConfirmStopModalHandler}
                />
            </Modal>
        ):null;

        const formsElementsArray =[];

        for(let key in this.state.disableAccountsForm) {
            formsElementsArray.push({
                id: key,
                config: this.state.disableAccountsForm[key]
            });
        }

        return(
            <DisplayBox>
                <div >
                    <h2 className={classes.header}>Bulk User Activity</h2>
                    <p className={classes.reqrow}>Requirements:</p>
                    <p className={classes.rows}>- File can have any number of columns. But, the data in first column should have Username/UUID.</p>
                    <p className={classes.rows}>- First row in the file is for the header.</p>
                    <p className={classes.rows}>- First column in the header row should be named as  "Username/UUID".</p>
                    <p className={classes.rows}>- File should be a csv file with extension ".csv".</p>
                    <p className={classes.rows}>- Values in the file should be separated with comma( , ) if the file contains more than one column.</p>
                    <div><h4 className={classes.subheader}>Select User Activity </h4>
                    <div style={{marginLeft:"50px"}}>
                    {formsElementsArray.map(formElement => (
                        <Input
                            key={formElement.id}
                            elementType={formElement.config.elementType}
                            elementConfig={formElement.config.elementConfig}
                            value={formElement.config.value}
                            invalid={!formElement.config.valid}
                            shouldValidate={formElement.config.validation}
                            touched={formElement.config.touched}
                            disabled={formElement.config.disabled}
                            disableMobApp={formElement.config.disableMobApp}
                            label={formElement.config.label}
                            changed={(event) => this.inputChangedHandler(event, formElement.id)}
                            extendedInput={formElement.config.extendedInput}
                            inputType={formElement.config.inputType}
                        />
                    ))}
                    </div>
                    </div>

                    {this.state.selectedBulkActivity !== "cancelBulkUserActivity" && (
                        <>
                        { this.state.selectedBulkActivity !== "bulkDeleteWithFilename" &&this.state.selectedBulkActivity!=="bulkEimpSyncWithFilename"&& (
                            <>
                                <h4 className={classes.subheader}>Select a CSV file</h4>
                                <input type="file" id="files" name="file" style={{ display: 'none'}} accept=".csv" onChange={(e) => this.checkFileType(e)} onClick={e => (e.target.value = null)}></input>
                                <label htmlFor="files" className={this.state.isBrowseBtnDisabled  ? [classes.Browsebtn, classes.BrowseBtnDisabled].join(' ') : classes.Browsebtn}>Browse</label>
                                <p className={classes.attachment}>{this.state.attachment?this.state.attachment:"No files selected"}</p>
                            </>
                        ) }

                        { (this.state.selectedBulkActivity == "bulkDeleteWithFilename" || this.state.selectedBulkActivity=="bulkEimpSyncWithFilename") && (
                            <>
                                <Input
                                    key={"fileName"}
                                    elementType={'input'}
                                    elementConfig={{
                                        type: 'text',
                                        id: 'filename',
                                        placeholder: 'Filename',
                                        maxLength: 41
                                    }}
                                    value={this.state.fileName}
                                    invalid={false}
                                    shouldValidate={{required: false}}
                                    touched={false}
                                    disabled={false}
                                    disableMobApp={false}
                                    label={"Filename"}
                                    changed={(event) => this.changeFileNameHandler(event)}
                                    inputType="OneFifthInlineBlockBulk"
                                />
                                <Input
                                    elementType={"checkbox"}
                                    id={"fromOutputFolder"}
                                    label={"File present in output folder"}
                                    // value={this.state.fromOutputFolder}
                                    checked={this.state.fromOutputFolder}
                                    changed={this.handleCheckboxChange}
                                    inputType="OneFifthInlineBlockBulk"
                                />
                            </>
                        ) }

                        <Button id="disableSubmit" btnType="DisableSubmit" disabled={(!this.state.fileName && !this.state.file) || this.isValidFilename()} clicked={() => { this.setState({ confirmShowModal: true }) }}>Submit</Button>

                        { (this.state.selectedBulkActivity == "bulkDeleteWithFilename" || this.state.selectedBulkActivity == "bulkDelete" ) && (
                            <div>
                                <div style={{marginLeft:"50px"}}>
                                    <Input
                                        elementType="checkbox"
                                        id="skipHsidPdb"
                                        label="Skip Member DB Updates"
                                        checked={this.state.skipOptions.skipHsidPdb}
                                        changed={() => this.handleSkipCheckboxChange("skipHsidPdb")}
                                        inputType="skipInput"
                                    />

                                    <Input
                                        elementType="checkbox"
                                        id="skipAikyam"
                                        label="Skip User DB updates"
                                        checked={this.state.skipOptions.skipAikyam}
                                        changed={() => this.handleSkipCheckboxChange("skipAikyam")}
                                        inputType="skipInput"
                                    />
                                    <Input
                                        elementType="checkbox"
                                        id="skipKafka"
                                        label="Skip EiMP de-link"
                                        checked={this.state.skipOptions.skipKafka}
                                        changed={() => this.handleSkipCheckboxChange("skipKafka")}
                                        inputType="skipInput"
                                    />
                                </div>
                            </div>
                        ) }
                        </>
                    )}

                    {this.state.selectedBulkActivity == "cancelBulkUserActivity" && (
                        <>
                            <Input
                                key={"jobId"}
                                elementType={'input'}
                                elementConfig={{
                                    type: 'text',
                                    id: 'jobId',
                                    placeholder: 'Job ID',
                                    maxLength: 41
                                }}
                                value={this.state.jobId}
                                invalid={false}
                                shouldValidate={{required: false}}
                                touched={false}
                                disabled={false}
                                disableMobApp={false}
                                label={"Job Id"}
                                changed={(event) => this.changeJobIdHandler(event)}
                                inputType="OneFifthInlineBlockBulk"
                            />
                            <Button id="disableSubmit" btnType="DisableSubmit" disabled={!this.state.jobId} clicked={() => {this.setState({confirmStopShowModal: true})}}>Stop Job</Button>
                        </>
                    ) }
                    {stateError}
                </div>
                {modalWindow}
                {confirmModalWindow}
                {confirmStopModalWindow}
            </DisplayBox>
        );
    }
}

const mapStateToProps = state => {
    return {
        userAuthToken: state.usr.token,
        userInfo: state.usr.user,
        bulkDisableResponse: state.member.bulkDisableResponse,
        bulkLockingResponse: state.member.bulkLockingResponse,
        bulkLdapUnlockResponse: state.member.bulkLdapUnlockResponse,
        bulkDisableErrorResponse: state.member.bulkDisableErrorResponse,
        bulkLockingErrorResponse: state.member.bulkLockingErrorResponse,
        bulkLdapUnlockErrorResponse: state.member.bulkLdapUnlockErrorResponse,
        bulkLockingResponse: state.member.bulkLockingResponse,
        bulkDeleteResponse: state.member.bulkDeleteResponse,
        bulkDeleteErrorResponse: state.member.bulkDeleteErrorResponse,
        bulkEimpSyncResponse: state.member.bulkEimpSyncResponse,
        bulkEimpSyncErrorResponse: state.member.bulkEimpSyncErrorResponse,
        spinnerProcessing: state.member.spinnerProcessing,
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        bulkDisableAccounts: (file, token) => dispatch(actions.bulkDisableAccounts(file, token)),
        bulkLockingAccounts: (file, token) => dispatch(actions.bulkLockingAccounts(file, token)),
        bulkLdapUnlockAccounts: (file, token) => dispatch(actions.bulkLdapUnlockAccounts(file, token)),
        bulkDeleteAccounts: (file, token, skipOptions) => dispatch(actions.bulkDeleteAccounts(file, token, skipOptions)),
        bulkEimpSyncUuids: (file, token) => dispatch(actions.bulkEimpSyncUuids(file, token)),
        bulkDeleteWithFilenameAccounts: (fileData, token) => dispatch(actions.bulkDeleteWithFilenameAccounts(fileData, token)),
        bulkEimpSyncWithFilenameAccounts: (fileData, token) => dispatch(actions.bulkEimpSyncWithFilenameAccounts(fileData, token)),
        bulkDeleteStop: (jobId, token) => dispatch(actions.bulkDeleteStop(jobId, token)),
        setResponseToNull: () => dispatch(actions.setResponseToNull()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DisableAccounts);